/* dependencies:
 * 1) post-robot
 * 2) history
 * use like:
  * import * as IntegrationAcc from 'app/utils/intagrationAccount';
  *
  * Component {
 *  constructor(props) {
 *   super(parops)
 *    const integrationAcc = new IntegrationAcc.IntegrationAccount('/', props.history);
      integrationAcc.start();
 *  }
 * }
  * */

 import { History } from 'history';
 const postRobot = require('post-robot');

 export interface Location {
    pathname: string;
    search: string;
    hash: string;
  }
  export enum PostRobotMesageType {
    goTo = 'goTo',
    goto = 'goto',
    goout = 'goOut',
  }
  export interface PostRobotMessage {
    url: string;
  }
  export interface PostRobotMessageEvent {
    data: {
      url: string;
    };
  }
 
 export class IntegrationAccount {
 
   private readonly history: History;
   private readonly basePath: string;
   private historyUnlisten?: Function;
 
   constructor(basePath: string = '', history: History) {
     this.basePath = basePath;
     this.history = history;
   }
 
   sendToParent = (type: PostRobotMesageType, data?: PostRobotMessage) => {
     window.parent !== window && postRobot.sendToParent(
       type,
       data,
     );
   };
 
   goToHandler = (ev: PostRobotMessageEvent) => {
     const { data } = ev;
     if (typeof data === 'object'
       && data !== null
       && typeof data.url === 'string'
     ) {
       const url = data.url.trim().replace(/^\/#|[ ]/g,'');
       this.history.replace(url.startsWith('/') ? url : `/${url}`);
       console.log('IntegrationAccount:goto', url, window.location.href);
     }
   };
 
   start() {
     this.historyUnlisten = this.history.listen((location: any) => {
       const url = <string>`${location.pathname}${location.search}${location.hash}`;
       const idx = url.indexOf(this.basePath);
       if (idx !== -1) {
         const relativeUrl = url.substr(idx + this.basePath.length);
         console.log(`IntegrationAccount: send ${relativeUrl}`);
         this.sendToParent(PostRobotMesageType.goTo, { url: relativeUrl });
       } else console.log(`IntegrationAccount: Base url was not found in ${url}`);
     });
     postRobot.on(PostRobotMesageType.goto, { window: window.parent }, this.goToHandler);
   }
 
   stop() {
     if (this.historyUnlisten) {
       this.sendToParent(PostRobotMesageType.goout);
       <Function>this.historyUnlisten();
     };
   }
 
 }
 



// WEBPACK FOOTER //
// ./src/integration/index.ts